"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
module.exports = angular.module('backstage.components.common.server-selection', []).component('bsServerSelection', {
  template: "        <div class=\"bs-server-selection\">\n            <select class=\"input-large\"\n                    ng-model=\"vm.group\"\n                    required\n                    ng-options=\"group as groupName\n                                for (group, groupName) in vm.servers\"\n                    ng-change=\"vm.onSelectedRegionChange()\">\n            </select>\n        </div>        ",
  controller:
  /*#__PURE__*/
  /* @ngInject */
  function () {
    BsServerSelectionViewModel.$inject = ["$window", "serverService", "$scope"];
    function BsServerSelectionViewModel($window, serverService, $scope) {
      var _this = this;
      _classCallCheck(this, BsServerSelectionViewModel);
      this.$window = $window;
      this.serverService = serverService;
      $scope.$watch('vm.org', function () {
        if (!_this.org) {
          return;
        }
        return _this.loadServers().then(function (servers) {
          return _this.servers = servers;
        });
      });
    }
    _createClass(BsServerSelectionViewModel, [{
      key: "onSelectedRegionChange",
      value: function onSelectedRegionChange() {
        return this.groupName = this.servers[this.group];
      }
    }, {
      key: "loadServers",
      value: function loadServers() {
        var split = this.org.split(':');
        return this.serverService.getOrgServers(split[1]);
      }
    }]);
    return BsServerSelectionViewModel;
  }(),
  controllerAs: 'vm',
  bindings: {
    group: '=',
    groupName: '=',
    org: '=',
    stage: '='
  }
}).name;